import { Component, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ApiserviceService } from '../../../apiservice.service';
import { ProfileDialog } from '../profile/profile.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-usermenu',
  templateUrl: './usermenu.component.html',
  styleUrls: ['./usermenu.component.css']
})
export class UsermenuComponent implements OnDestroy{

  private subs = new Subscription();
  constructor(public router: Router, public api:ApiserviceService, public dialog: MatDialog) {
  }
  logout(val){
    this.api.logout(val);
  }
  openProfile(){
    let dialogRef = this.dialog.open(ProfileDialog, {
      width: '450px',
      panelClass: 'create-master-panel',
      data: { parent: this }//optional
    });
    const openDiaSub = dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
    this.subs.add(openDiaSub);
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
